import { render, staticRenderFns } from "./WishCard.vue?vue&type=template&id=4a646a60&"
import script from "./WishCard.vue?vue&type=script&lang=js&"
export * from "./WishCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports